import { Component, OnInit } from '@angular/core';

import { IPageComponent } from '../../interfaces/ipagecomponent';

/**
 * Composant de gestion des horaires du point relais
 * @extends IPageComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-horaire-point-relais',
  templateUrl: './horaire-point-relais.component.html',
  styleUrls: ['./horaire-point-relais.component.scss']
})
export class HorairePointRelaisComponent extends IPageComponent implements OnInit {

    jours: string[];

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.jours = [
            'Lundi',
            'Mardi',
            'Mercredi',
            'Jeudi',
            'Vendredi',
            'Samedi',
            'Dimanche'
        ];
    }

}
